import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dataLoadUsersAsync } from '../utils/dataApi';

export const fetchUsers = createAsyncThunk('users/fetchUsers', async () => {
  const response = await dataLoadUsersAsync();
  return response.map(user => ({
    ...user,
    email: user.email.toLowerCase(),
    coreId: user.email.split('@')[0].toLowerCase(),
  }));
});

const initialState = {
  users: [],
  status: 'idle',
  error: null,
  allUsers: [],
  managedUsers: [],
  userObj: null,
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    clearUsers: (state) => {
      state.users = [];
    },
    totalClearUsers: () => initialState,
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    setAllUsers: (state, action) => {
      state.allUsers = action.payload;
    },
    setManagedUsers: (state, action) => {
      state.managedUsers = action.payload;
    },
    setUserObj: (state, action) => {
      state.userObj = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.users = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const dispatchUsersForRole = (dispatch, selectedRole, allUsers, managedUsers, userObj) => {
  if (selectedRole === 'Admin') {
    dispatch(setUsers(allUsers));
  } else if (selectedRole === 'Manager') {
    dispatch(setUsers(managedUsers));
  } else if (selectedRole === 'User') {
    dispatch(setUsers([userObj]));
  } else {
    throw new Error('dispatchUsersForRole:  Unknown selected role: ' + selectedRole);
  }
}

export const dispatchUsersForAllRoles = (dispatch, allUsers, managedUsers, userObj) => {
  dispatch(setAllUsers(allUsers));
  dispatch(setManagedUsers(managedUsers));
  dispatch(setUserObj(userObj));
}

export const { clearUsers, totalClearUsers, setUsers, setAllUsers, setManagedUsers, setUserObj } = usersSlice.actions;

export default usersSlice.reducer;

